import { Pipe, PipeTransform } from '@angular/core';

export interface KeyValuePair<T> {
    key: string;
    value: T;
}

export interface ObjectOfTypes<T> {
    [key: string]: T;
}

@Pipe({
    name: 'keyValues',
    standalone: false
})
export class KeysPipe implements PipeTransform {
    transform<T>(value: ObjectOfTypes<T>, args: string[]): Array<KeyValuePair<T>> {
        const pairs: Array<KeyValuePair<T>> = [];
        for (const field in value) {
            if (value.hasOwnProperty(field)) {
                pairs.push({key: field, value: value[field]});
            }
        }
        return pairs;
    }
}

